<template>
	<a class="fav-link" :class="{'hasBeenSelected': favorites.indexOf(postId) !== -1}" href="javascript:void(0)">
		<span class="empty"><img :src="svgIconUrl+'esmark-hjerte.svg'" /></span>
		<span class="full"><img :src="svgIconUrl+'esmark-hjerte-fyldt.svg'" /></span>
		<span class="text">{{translations.sentences.addToFavorites}}</span>
	</a>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		props: {
			postId: Number
		},
		computed: {
			...mapState({
				svgIconUrl: 'svgIconUrl',
				favorites: 'favorites',
				translations: 'translations'
			}),
		}
	}
</script>

<style scoped>

</style>
